const Link = {
  variants: {
    primary: {
      color: 'brand.500',
    },
  },
}

export default Link
